import Alpine from 'alpinejs';

Alpine.data('pricingcard', () => ({
  toggle: false,
  plan: 'month',
  init() {
    this.config = JSON.parse(this.$el.dataset.jsPricingcardConfig || '{}');
    this.$watch('toggle', (val) => {
      this.plan = val ? 'year' : 'month';
    });
  },
  planPer() {
    return this.config[this.plan].plan_per;
  },
  pricing() {
    return this.config[this.plan].pricing;
  }
}));

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-js-pricingcard-config]').forEach((el) => {
    el.querySelectorAll('.plan-price').forEach((price) => {
      price.setAttribute('x-text', 'pricing');
    });
    el.querySelectorAll('.pt-card--toggle-container a').forEach((toggleLink, ix) => {
      toggleLink.setAttribute('x-on:click.prevent', `toggle=${ix ? true : false}`);
    });
    el.querySelectorAll('.plan-per').forEach((pEl) => {
      pEl.setAttribute('x-html', 'planPer');
    });
    el.querySelectorAll('[class*=ckbx-style] input').forEach((cbox) => {
      cbox.setAttribute('x-model', 'toggle');
    });
  });

  Alpine.start();
});
